import state from './area.state'
import mutations from './area.mutations'
import actions from './area.actions'

export default {
  state,
  mutations,
  actions
}
